import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';
import * as typography from '@tapas/typography';
var StyledLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  position: absolute;\n  top: 1.7rem;\n  left: 1.6rem;\n  width: 100%;\n  height: 2.4rem;\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 100ms;\n  color: ", ";\n\n  ", ";\n"], ["\n  ", "\n  box-sizing: border-box;\n  position: absolute;\n  top: 1.7rem;\n  left: 1.6rem;\n  width: 100%;\n  height: 2.4rem;\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 100ms;\n  color: ", ";\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme,
      isFocused = _a.isFocused,
      inputValue = _a.inputValue;
  return isFocused || inputValue ? typography.caption(theme.fonts.default, 300) : typography.body(theme.fonts.default, 1.6, 300);
}, function (_a) {
  var theme = _a.theme,
      disabled = _a.disabled,
      validState = _a.validState,
      readOnly = _a.readOnly;

  if (readOnly) {
    return theme.colorTokens.text.primary;
  }

  if (disabled) {
    return theme.colorTokens.text.disabled;
  }

  if (validState === 'error') {
    return theme.colors.danger;
  }

  return theme.colorTokens.text.placeholder;
}, function (_a) {
  var isFocused = _a.isFocused,
      inputValue = _a.inputValue;
  return (isFocused || inputValue) && "\n    top: 0.8rem;\n    height: 1.8rem;\n  ";
});
var StyledInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  background-color: ", ";\n  width: 100%;\n  height: 5.8rem;\n  border: 0.1rem solid\n    ", ";\n  border-radius: 0.8rem;\n  outline: none;\n  padding: ", ";\n  color: ", ";\n  transition: border-color linear 100ms;\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  :hover {\n    border-color: ", ";\n  }\n\n  :focus {\n    border-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n"], ["\n  ", "\n  box-sizing: border-box;\n  background-color: ", ";\n  width: 100%;\n  height: 5.8rem;\n  border: 0.1rem solid\n    ", ";\n  border-radius: 0.8rem;\n  outline: none;\n  padding: ", ";\n  color: ", ";\n  transition: border-color linear 100ms;\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  :hover {\n    border-color: ", ";\n  }\n\n  :focus {\n    border-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      type = _a.type;
  return type === 'password' ? 'font-size: 1.6rem; line-height: 2.4rem; letter-spacing: -0.02rem;' : typography.body(theme.fonts.default, 1.6, 300);
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.background.base;
}, function (_a) {
  var theme = _a.theme,
      validState = _a.validState;
  return validState !== 'error' ? theme.colorTokens.hierarchy.h4 : theme.colorTokens.system.danger.default;
}, function (_a) {
  var isFocused = _a.isFocused,
      value = _a.value,
      labelOfInput = _a.labelOfInput;
  return labelOfInput.trim() && (isFocused || value) ? '2.6rem 1.6rem 0.8rem' : '1.7rem 1.6rem';
}, function (_a) {
  var theme = _a.theme,
      disabled = _a.disabled;
  return disabled ? theme.colorTokens.text.disabled : theme.colorTokens.text.primary;
}, function (_a) {
  var theme = _a.theme,
      disabled = _a.disabled;
  return disabled ? theme.colorTokens.hierarchy.h4 : theme.colorTokens.hierarchy.h2;
}, function (_a) {
  var theme = _a.theme,
      validState = _a.validState;
  return validState === 'error' ? theme.colorTokens.system.danger.default : theme.colorTokens.accent.default;
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.hierarchy.h5;
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.hierarchy.h4;
}, function (_a) {
  var theme = _a.theme,
      readOnly = _a.readOnly;
  return readOnly && "\n    cursor: default;\n    background-color: " + theme.colorTokens.hierarchy.h6 + " !important;\n    border-color: " + theme.colorTokens.hierarchy.h4 + " !important;\n    ";
});
var StyledInputWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 5.8rem;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 5.8rem;\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return typography.body(theme.fonts.default);
});
var CountWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  ", "\n  position: absolute;\n  width: 3rem;\n  height: 1.8rem;\n  right: 1.6rem;\n  top: calc(50% - 1.8rem / 2);\n  /* identical to box height, or 150% */\n\n  display: flex;\n  align-items: center;\n  text-align: right;\n\n  color: ", ";\n"], ["\n  box-sizing: border-box;\n  ", "\n  position: absolute;\n  width: 3rem;\n  height: 1.8rem;\n  right: 1.6rem;\n  top: calc(50% - 1.8rem / 2);\n  /* identical to box height, or 150% */\n\n  display: flex;\n  align-items: center;\n  text-align: right;\n\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return typography.caption(theme.fonts.default, 500);
}, function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.text.placeholder;
});
var IconButton = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  top: 1.7rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  right: ", "rem;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  top: 1.7rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  right: ", "rem;\n"])), function (_a) {
  var right = _a.right;
  return right;
});
var StyledIconDiv = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  top: 1.7rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  right: ", "rem;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  top: 1.7rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  right: ", "rem;\n"])), function (_a) {
  var right = _a.right;
  return right;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
export { CountWrapper, IconButton, StyledIconDiv, StyledInput, StyledInputWrapper, StyledLabel };